// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__rL6El","btn":"ErrorPage_btn__Wpfz9","card":"ErrorPage_card__BipRF","msg":"ErrorPage_msg__V7AOb"};